/**
 * Раскрывает литеральные escape-последовательности в читаемый UTF-8.
 * Бэкенд (Go %q / двойное экранирование) часто отдаёт `\u041f` или `\xD0\x9F`
 * как текст, а не как уже разобранную строку.
 */
export const decodeUtf8Message = (value?: string): string => {
  if (!value) {
    return '';
  }

  let result = value;

  // Байты UTF-8 в виде \xD0\x9F… → символы.
  if (/\\x[0-9a-fA-F]{2}/.test(result)) {
    result = result.replace(/(?:\\x[0-9a-fA-F]{2})+/g, (sequence) => {
      const bytes = Array.from(sequence.matchAll(/\\x([0-9a-fA-F]{2})/g), (match) =>
        parseInt(match[1], 16)
      );
      try {
        return new TextDecoder('utf-8').decode(new Uint8Array(bytes));
      } catch (e) {
        return sequence;
      }
    });
  }

  // Юникод-эскейпы \u041f… и простые \n \r \t → символы.
  if (/\\[nrt]|\\u[0-9a-fA-F]{4}/.test(result)) {
    result = result
      .replace(/\\u([0-9a-fA-F]{4})/g, (_, hex: string) => String.fromCharCode(parseInt(hex, 16)))
      .replace(/\\n/g, '\n')
      .replace(/\\r/g, '\r')
      .replace(/\\t/g, '\t');
  }

  return result;
};
